import React, { Fragment } from 'react'
import GeneralInputMask from '../../../../../components/GeneralInputMask'
import './style.scss'

const CreditUpdateCpf = ({ registerCpf, handleChangeCpf, handleUpdateUser, error }) => (
  <div>
    {registerCpf && (
      <div>
        <Fragment>
          {Boolean(error) && (
            <p style={{ color: 'red', textAlign: 'center', margin: 16 }}>{error}</p>
          )}
        </Fragment>
        <div>
          <GeneralInputMask
            handleChange={handleChangeCpf}
            mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
            label='CPF'
          />
          <div className='update_group'>
            <button onClick={handleUpdateUser} className='update_button'>
              Cadastrar
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)

// TODO: use ts
// CreditUpdateCpf.propTypes = {
//   error: PropTypes.string,
//   registerCpf: PropTypes.bool,
//   handleChangeCpf: PropTypes.func,
//   handleUpdateUser: PropTypes.func,
// }

export default CreditUpdateCpf
